import React from "react";


import imgFigma from "../../../../src/assets/images/figma.png";
import imgLaravel from "../../../../src/assets/images/laravel.png";
import imgFramer from "../../../../src/assets/images/framer.png";
import imgWebflow from "../../../../src/assets/images/webflow.png";
import imgReact from "../../../../src/assets/images/react.png";
import imgWordpress from "../../../../src/assets/images/wordpress.png";

function SkillsArea() {
  return (
    <>
      <section className="skills-area page-section scroll-to-page" id="skills">
        <div className="custom-container">
          <div className="skills-content content-width">
            <div className="section-header">
              <h4
                className="subtitle scroll-animation"
                data-animation="fade_from_bottom"
              >
                <i className="las la-shapes"></i> my skills
              </h4>
              <h1
                className="scroll-animation"
                data-animation="fade_from_bottom"
              >
                My <span>Advantages</span>
              </h1>
            </div>

            <div className="row skills text-center">
              <div
                className="col-md-3 scroll-animation"
                data-animation="fade_from_left"
              >
                <div className="skill">
                  <div className="skill-inner">
                    <img src={imgFigma} alt="Figma" />
                  </div>
                  <p className="name">Figma</p>
                </div>
              </div>
              <div
                className="col-md-3 scroll-animation"
                data-animation="fade_from_bottom"
              >
                <div className="skill">
                  <div className="skill-inner">
                    <img src={imgFramer} alt="Framer" />
                  </div>
                  <p className="name">Framer</p>
                </div>
              </div>
              <div
                className="col-md-3 scroll-animation"
                data-animation="fade_from_top"
              >
                <div className="skill">
                  <div className="skill-inner">
                    <img src={imgWebflow} alt="Webflow" />
                  </div>
                  <p className="name">Webflow</p>
                </div>
              </div>
              <div
                className="col-md-3 scroll-animation"
                data-animation="fade_from_right"
              >
                <div className="skill">
                  <div className="skill-inner">
                    <img src={imgReact} alt="React" />
                  </div>
                  <p className="name">React</p>
                </div>
              </div>
              <div
                className="col-md-3 scroll-animation"
                data-animation="fade_from_left"
              >
                <div className="skill">
                  <div className="skill-inner">
                    <img src={imgWordpress} alt="WordPress" />
                  </div>
                  <p className="name">WordPress</p>
                </div>
              </div>
              <div
                className="col-md-3 scroll-animation"
                data-animation="fade_from_bottom"
              >
                <div className="skill">
                  <div className="skill-inner">
                    <img src={imgLaravel} alt="Laravel/PHP" />
                  </div>
                  <p className="name">Laravel/PHP</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default SkillsArea;
